import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Button} from '@betareader/design-system';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  sendReadingReminder
} from '../../../modules/reader';

export class InActiveReadersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.readerEntries.length > 0 && this.props.readerEntries.length === 0) {
      this.props.onClose();
    }
  }

  // custom methods
  sendReminder = (reader) => {
    const {idToken} = this.props;
    this.props.sendReadingReminder(idToken, reader);
  }

  // rendering
  render() {
    const { readerEntries, readOnly, t } = this.props;
    const threeDaysAgo = new Date();
    threeDaysAgo.setDate(threeDaysAgo.getDate()-3);
    return (
      <ul style={{listStyle: 'none', margin: 0, padding: 0}}>
        {
          (readerEntries || []).map((reader, index) => {
            const allowReminding = (reader.invitation.remindedAt === undefined || new Date(reader.invitation.remindedAt) < threeDaysAgo);
            return (
              <li key={reader._id} style={{padding: '0.75em 0', borderBottom: '1px solid var(--br-border)'}}>
                <div style={{float: 'right'}}>
                  <Button
                    size='small'
                    disabled={!allowReminding || readOnly || reader.updating}
                    aria-busy={reader.updating}
                    onClick={() => {this.sendReminder(reader)}}>
                    {t('SendReminder')}
                  </Button>
                  {
                    !allowReminding &&
                    <div style={{fontSize:'0.8em',maxWidth:150}}>{t('YouCanSendAReminderEvery3Days')}</div>
                  }
                </div>
                <strong>
                  {reader.name}
                </strong>
                <div>
                  <div style={{fontSize:'0.9em'}}>
                    <div>
                      {t('LastSeenAt')} <strong>{reader.readingData.lastSeenAtPartTitle}</strong> {moment(reader.readingData.lastSeenAtDate || reader.createdAt).fromNow()}
                      <br/>
                    </div>
                    {
                      reader.invitation.remindedAt &&
                      <div>
                        <span>{t('ReminderSentAt')}: {moment(reader.invitation.remindedAt).fromNow()}</span>
                      </div>
                    }
                  </div>
                </div>
              </li>
            );
          })
        }
    </ul>
    )

  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  sendReadingReminder,
}, dispatch)

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(InActiveReadersList)));
